/* 🤖 this file was generated by svg-to-ts */
export const matIconAddCard: {
  name: 'add-card';
  data: string;
} = {
  name: 'add-card',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M20 4H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h10v-2H4v-6h18V6c0-1.11-.89-2-2-2zm0 4H4V6h16v2zm4 9v2h-3v3h-2v-3h-3v-2h3v-3h2v3h3z"/></svg>`
};
